var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.tablet,style:({'max-width': _vm.$props.width, 'max-height': _vm.$props.height})},[_vm._t("default"),_c('div',{class:_vm.$style.professor,style:({'bottom': _vm.$props.profBottom, 'right': _vm.$props.profRight})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }